import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { ProgramsService } from '../services/programs.service';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';

@Injectable()
export class CreatorProgramsListResolver implements Resolve<Observable<string>> {

    constructor(private programsService: ProgramsService) { }

    resolve() {
        return this.programsService.getCreatorPrograms().catch(() => {
            return Observable.of('error');
        });
    }

}

